<template>
  <AppHeader>Pending Bottle Summary</AppHeader>

  <div class="flex items-center justify-center mx-10 mt-4 text-3xl text-gray-600">
    <b>{{ toDate(date) }}</b>
  </div>

  <Loading v-if="state == 'loading'"></Loading>

  <div v-if="state == 'idle'" class="p-4">
    <div class="mt-4 responsive-table">
      <table>
        <thead>
          <tr>
            <th>Area Name</th>
            <th>Customers</th>
            <th v-for="product in products" :key="product.id">{{ product.name  }} ({{ product.quantity }})</th>
            <th>Total Bottles</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="customer in customers" :key="customer.id">
            <td>{{ customer.area_name }}</td>
            <td class="capitalize">{{ customer.name }} <small>(#{{ customer.id }})</small></td>
            <td v-for="(product, id) in products" :key="id">
              {{ (customer.product_count.find(p => p.id === product.id) || { count: 0 }).count }}
            </td>
            <td>{{ customer.pending_count }}</td>
            <td align="center">
              <a @click="initiateCall(customer.phone)" class="px-2"><i class="ion-md-call"></i></a>
              <button @click="initiateMessage('customer', customer.id, 'sms', 'empty_bottle_reminder' )" class="px-1 text-gray-800" title="Send SMS"><i class="ion-md-mail text-xl"></i></button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin.js';
import AppHeader from '@/components/common/Header.vue';
import Loading from '@/components/common/Loading.vue';

export default {
  name: 'ReportPendingBottleReturnSummary',
  mixins: [ mixin ],
  components: { AppHeader, Loading},

  data() {
    return {
      state: 'loading',
      date: null,
      customers: [],
      products: [],
    }
  },

  methods: {
    getData() {
      this.state = 'loading';

      this.request('GET', 'reports/pending-bottle-return-summary/' + this.date, {}, (resp) => {
        this.state = 'idle';
        if (resp.success) {
          this.customers = resp.data.customers;
          this.products = resp.data.products;
         } else {
          alert(resp.message);
        }
      });
    },
  },

  mounted() {
    this.date = new Date().toISOString().slice(0, 10);
    this.getData();
  }
}
</script>
